import { LinearProgress } from '@material-ui/core';
import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FILE_TYPE } from '../constant/Constant';
import { actionFileUpload, actionFileDownload } from '../module/component/FileAttachModule';
import NullCheckUtil from '../util/NullCheckUtil';
import PopupRef from './PopupRef';

const SingleFileAttachBox = ({
    labelName,
    fileUid,
    fileNm,
    onChangeFile,
    editable,
    download,
    availableTypes = [FILE_TYPE.PDF],
    fileTypeErrorMsg,
}) => {
    const dispatch = useDispatch();
    const popupRef = useRef(null);
    // useRef를 이용해 input태그에 접근한다.
    const fileUploadInput = useRef(null);
    const [fileSize, setFileSize] = useState(0);
    const [uploadSize, setUploadSize] = useState(0);

    const _handleOnChangeUploadFile = (e) => {
        if (e.target.files[0]) {
            const [file] = e.target.files;
            if (!availableTypes.includes(file.type)) {
                popupRef.current.openAlert(fileTypeErrorMsg);
            } else {
                setFileSize(file.size);
                dispatch(
                    actionFileUpload({
                        params: {
                            file,
                        },
                        callback: (result) => {
                            onChangeFile(result);
                        },
                        uploadProgress: (loaded) => {
                            setUploadSize(loaded);
                        },
                    }),
                );
            }
        }
    };

    const handleOnClickUploadFile = (e) => {
        fileUploadInput.current.value = '';
        fileUploadInput.current.click();
    };

    const handleOnChangeDownloadFile = (e) => {
        if (NullCheckUtil.isNotEmpty(fileUid)) {
            dispatch(
                actionFileDownload({
                    params: {
                        fileUid,
                    },
                }),
            );
        }
    };

    const handleOnChangeDeleteFile = (e) => {
        popupRef.current.openWarning('등록한 파일을 삭제하시겠습니까?', () => {
            return function () {
                onChangeFile({ fileUid: null, fileNm: null });
            };
        });
    };

    return (
        <>
            <div className='form-box'>
                <div className='input-box add-btn'>
                    <label htmlFor='add-file'>{labelName}</label>
                    <div className='input-box-group'>
                        <div className='input-group'>
                            <div className={'attach-file-box ' + (editable ? '' : 'disabled')}>
                                <div className='box-inner'>
                                    <input
                                        id='attach-file-input'
                                        type='file'
                                        style={{ display: 'none' }}
                                        className='form-control'
                                        ref={fileUploadInput}
                                        onClick={() => setUploadSize(0)}
                                        onChange={(e) => _handleOnChangeUploadFile(e)}
                                    />
                                    <span className='file-name'>{fileNm}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='btn-file'>
                        {download && fileNm && (
                            <button
                                type='button'
                                className='btn file-down'
                                onClick={(e) => handleOnChangeDownloadFile(e)}
                            />
                        )}
                        {editable && (
                            <>
                                <button
                                    type='button'
                                    className='btn file-up'
                                    onClick={(e) => handleOnClickUploadFile(e)}
                                />
                                {fileNm && (
                                    <button
                                        type='button'
                                        className='btn file-del'
                                        onClick={(e) => handleOnChangeDeleteFile(e)}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div>
                <LinearProgress
                    variant='determinate'
                    value={uploadSize == fileSize ? (fileSize > 0 ? 100 : 0) : (uploadSize * 100) / fileSize}
                />
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default SingleFileAttachBox;
